import * as React from 'react';
import * as Modal from 'react-modal';
import { SurveyWidget, ISurveyWidgetProps } from '@cian/commercial-survey-widget';

import * as styles from './index.css';

export interface ISurveyWidgetModalProps extends ISurveyWidgetProps {
  isOpen: boolean;
  onSOPREvent?(action: string, label: string): void;
}

export const SurveyWidgetModal: React.SFC<ISurveyWidgetModalProps> = ({ isOpen, ...props }) => {
  React.useEffect(() => {
    // Если модальное окно открыто,
    // то блокируем глобальный скролл,
    // чтобы контент под окном не скроллился
    document.body.style.overflow = isOpen ? 'hidden' : '';
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      ariaHideApp={false}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      style={{
        content: {
          overflow: 'hidden',
          padding: 0,
          position: 'static',
        },
        overlay: {
          alignItems: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          display: 'flex',
          justifyContent: 'center',
          zIndex: 100,
        },
      }}
    >
      <div className={styles['body']}>
        <SurveyWidget {...props} />
      </div>
    </Modal>
  );
};

SurveyWidgetModal.displayName = 'SurveyWidgetModal';
